import { UseInfiniteQueryResult } from '@tanstack/react-query';
import { UseErrorListReturn } from 'lib/utils/useErrorList';
import { useEffect } from 'react';

interface UseQueryDataErrorsOptions {
  query: UseInfiniteQueryResult<{ data: any }>;
  errorList: UseErrorListReturn;
  contextPrefix?: string;
}

/**
 * Hook to extract and add errors from query data to the error list.
 * This handles errors that are returned in the data payload itself.
 */
export function useQueryDataErrors(args: UseQueryDataErrorsOptions) {
  useEffect(
    () => {
      // Extract errors from paginated data
      const errors = [...(args.query.data?.pages ?? [])].flatMap(
        page => page?.data.errors ?? []
      );

      if (errors?.length !== 0) {
        errors.forEach(err => {
          const errorMessage = err.message || 'Unknown error';
          const errorId = err.userId;

          args.errorList.addError(
            new Error(`${args.contextPrefix}: ${errorMessage}`),
            errorId,
            `User (id=${errorId}) was not shown`
          );
        });
      }
    },
    // eslint-disable-next-line
    [args.query.data, args.errorList.addError, args.contextPrefix]
  );
}
